<rr-modal
  [modalSettings]="deleteModalSettings"
  [template]="
    contentType === MODAL_CONTENT_TYPE.HTML
      ? modalContentTemplate
      : confirmDeleteTemplate
  "
  [(showModal)]="show"
  (clickedButton)="onDeleteModalButtonClicked($event)"
  (showModalChange)="onShowModalChange($event)"
>
</rr-modal>

<ng-template #confirmDeleteTemplate>
  <div>
    {{ modalContentString }}
  </div>
</ng-template>
